// @flow
import $ from 'jquery';
import JQueryView from './JQueryView';
import { createPopper } from '@popperjs/core';

export default class HeaderDropdown extends JQueryView {
  constructor(
    buttonSelector: string,
    dropdownSelector: string,
    hover: boolean = true,
  ) {
    super('.header');
    const button: any = document.querySelector(buttonSelector);
    const dropdown: any = document.querySelector(dropdownSelector);

    const popper = createPopper(button, dropdown, {
      modifiers: [
        {
          name: 'offset',
          options: {
            // 1px上にずらして隙間を埋めることで、ドロップダウンにカーソルを乗せる時に閉じられないようにする
            offset: [-10, -1],
          },
        },
        {
          name: 'flip',
          options: {
            flipVariations: false,
          },
        },
      ],
      placement: 'bottom-start',
    });

    const show = () => {
      dropdown.setAttribute('data-show', '');
      popper.update();
    };

    const hide = () => {
      dropdown.removeAttribute('data-show');
    };

    const showEvents = ['mouseenter', 'focus'];
    const hideEvents = ['mouseleave', 'blur'];

    if (hover) {
      showEvents.forEach(event => {
        button.addEventListener(event, show);
        dropdown.addEventListener(event, show);
      });
    }

    hideEvents.forEach(event => {
      button.addEventListener(event, hide);
      dropdown.addEventListener(event, hide);
    });

    $(document).click(function(event) {
      if (event.target.closest(buttonSelector) == null) {
        dropdown.removeAttribute('data-click-show');
      } else {
        dropdown.setAttribute('data-click-show', '');
        popper.update();
      }
    });
  }
}
